export const afterAuth = ['listLibraries'];
